const domain = {
    prod: "apis.cicil.biz.id:8443",
    staging: "sapi.cicil.biz.id:8443",
    development: "dapi.cicil.biz.id:8443",
    swagger: "virtserver.swaggerhub.com/K3364/kawan_gajian/1.0.0"
};
export const login = `https://${domain.prod}/kancil/user/auth/apis/v1/admin`;
const api = `https://${domain.prod}`;
export default api;
